export default "__VITE_ASSET__BiE$0g5p__"